module.exports = __webpack_public_path__ + "static/media/darikSeke.8279bb00.webp";